import React from "react";
import CardLogin from "../components/login/CardLogin";

const LoginPage = () => {
  return <CardLogin />;
};

export default LoginPage;
